module.exports = __webpack_public_path__ + "assets/fca3b0ce6de1a641fbccef4e7ed843d5.png";